<template>
  <v-container fluid class="container-page">
    <v-row>
      <v-col
        cols="12"
        sm="12"
        md="12"
        lg="12"
        class="d-flex text-title-container"
      >
        <div class="text-title text-primary m-r-24">Insights</div>
      </v-col>

      <div
        class="expand-filter"
        :style="expandFilter ? widthExpand1 : widthExpand2"
      >
        <div
          v-if="expandFilter"
          class="border1"
          :class="isCalendarShow ? 'hide-scroll-y' : ''"
        >
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                class="icon-expand-filter"
                @click="expandFilter = !expandFilter"
                v-bind="attrs"
                v-on="on"
                >fas fa-angle-left</v-icon
              >
            </template>
            <span>Collapse filter</span>
          </v-tooltip>
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-select
                id="report"
                class="box-select"
                item-text="name"
                item-value="value"
                v-model="search.name"
                :items="insights"
                label="Insight"
                @change="reportChange"
                dense
                hide-details
              ></v-select>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12">
              <VueCtkDateTimePicker
                v-model="search.from"
                :max-date="search.to"
                :format="$datetimeFormatDefault"
                :no-value-to-custom-elem="true"
                :no-button-now="true"
                @is-hidden="dataChange()"
                @is-shown="setBorderStyle()"
              >
                <v-text-field
                  class="font-size-body"
                  v-model="dateFrom"
                  prepend-inner-icon="mdi-calendar small"
                  label="From"
                  readonly
                  dense
                  hide-details
                ></v-text-field>
              </VueCtkDateTimePicker>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12">
              <VueCtkDateTimePicker
                v-model="search.to"
                :min-date="search.from"
                :format="$datetimeFormatDefault"
                :no-value-to-custom-elem="true"
                :no-button-now="true"
                @is-hidden="dataChange()"
                @is-shown="setBorderStyle()"
              >
                <v-text-field
                  class="font-size-body"
                  v-model="dateTo"
                  prepend-inner-icon="mdi-calendar small"
                  label="To"
                  readonly
                  dense
                  hide-details
                ></v-text-field>
              </VueCtkDateTimePicker>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
              v-if="checkFilter('direction')"
            >
              <v-select
                v-model="search.direction"
                :items="directions"
                item-value="value"
                item-text="label"
                label="Direction"
                @change="dataChange"
                dense
                hide-details
              >
              </v-select>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
              v-if="checkFilter('channel_type')"
            >
              <v-select
                id="select-call-status"
                class="box-select"
                item-text="label"
                item-value="value"
                v-model="search.channelType"
                :items="channelTypeList"
                label="Channel type"
                hide-details
                @change="dataChange"
              ></v-select>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
              v-if="checkFilter('channel')"
            >
              <v-combobox
                v-model="channelSelected"
                :items="channels"
                item-value="value"
                item-text="label"
                hide-selected
                label="Channel"
                @change="dataChange"
                dense
                hide-details
              >
                <template v-slot:selection="{ attrs, item }">
                  <div class="d-flex align-center">
                    <v-icon v-if="item.icon" :class="item.class" class="m-r-5">
                      {{ item.icon }}
                    </v-icon>
                    <v-avatar v-if="item.img" size="20" class="m-r-5">
                      <img :src="item.img" :alt="item.label" />
                    </v-avatar>
                    {{ item.label ? item.label : channelSelected }}
                  </div>
                </template>
                <template v-slot:item="{ index, item }">
                  <v-list-item-content class="list-icon">
                    <div class="d-flex align-center">
                      <v-icon
                        v-if="item.icon"
                        :class="item.class"
                        class="m-r-5"
                      >
                        {{ item.icon }}
                      </v-icon>
                      <v-avatar v-if="item.img" size="22" class="m-r-5">
                        <img :src="item.img" :alt="item.label" />
                      </v-avatar>
                      {{ item.label }}
                    </div>
                  </v-list-item-content>
                </template>
              </v-combobox>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
              v-if="checkFilter('checkpoint_value')"
            >
              <v-text-field
                v-model="checkpointValue"
                label="Traffic threshold"
                @keyup="keyCheckpointValue"
                @blur="blurCheckpointValue"
                dense
                hide-details
              >
              </v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
              v-if="checkFilter('checkpoint_name')"
            >
              <v-text-field
                v-model="search.checkpoint_name"
                label="Highlight checkpoint"
                dense
                hide-details
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12" class="d-flex justify-end">
              <v-btn
                id="btn-show-report"
                class="btn-primary"
                @click="getInsight"
                :disabled="!search.name"
              >
                Run
              </v-btn>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12" class="d-flex p-t-0 p-b-0">
              <div v-if="search.name === 'bot_qc' && isShow && total !== 0">
                <span class="font-size-body">Download as</span>
                <v-icon
                  class="icon-excel m-l-20"
                  color="green darken-1"
                  @click="genReport('excel')"
                  data-file="excel"
                >
                  far fa-file-excel
                </v-icon>
                <v-icon
                  class="icon-excel m-l-10"
                  color="red lighten-1"
                  @click="genReport('pdf')"
                  data-file="excel"
                >
                  far fa-file-pdf
                </v-icon>
                <v-icon class="icon-excel m-l-10" @click="genReport('csv')">
                  fas fa-file-csv
                </v-icon>
              </div>
            </v-col>
          </v-row>
        </div>

        <div v-else class="border2">
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                class="icon-expand-filter"
                @click="expandFilter = !expandFilter"
                v-bind="attrs"
                v-on="on"
                >fas fa-angle-right</v-icon
              >
            </template>
            <span>Expand filter</span>
          </v-tooltip>
        </div>
      </div>

      <div
        class="container-report"
        :style="`${expandFilter ? widthCollapse1 : widthCollapse2}`"
      >
        <insight-component
          v-if="isShow"
          :search="search"
          :count="count"
          @checkTotalQc="checkTotalQc"
          @closeDialogLoading="closeDialogLoading"
        />
      </div>
    </v-row>

    <dialog-export-loading
      v-if="dialogExportLoading"
      :dialogExportLoading="dialogExportLoading"
    />

    <dialog-export-confirm
      v-if="dialogConfirm.open"
      :dialogConfirm="dialogConfirm"
    />
  </v-container>
</template>

<script>
import _ from 'lodash'
import Moment from 'moment'

import variables from '@/styles/variables.scss'

import InsightComponent from './components/index'

import apiInsight from '@/apis/insight'
import apiReport from '@/apis/report'

import Facebook from '@/assets/facebook.png'
import Line from '@/assets/line.png'

import DialogExportLoading from './components/dialog_export_loading'
import DialogExportConfirm from './components/dialog_export_confirm'

export default {
  components: {
    InsightComponent,
    DialogExportLoading,
    DialogExportConfirm
  },
  data() {
    return {
      insights: [],
      expandFilter: true,
      widthExpand1: 'width: 300px;',
      widthExpand2: 'width: 44px;',
      widthCollapse1: 'width: calc(100% - 310px);',
      widthCollapse2: 'width: calc(100% - 60px);',
      isCalendarShow: false,
      directions: [
        { value: 'inbound', label: 'Inbound' },
        { value: 'outbound', label: 'Outbound' }
      ],
      search: {
        name: '',
        from: '',
        to: '',
        direction: 'inbound',
        channelType: 'all',
        channel: 'all',
        checkpoint_name: '',
        checkpoint_value: 1
      },
      format: 'YYYY-MM-DD HH:mm',
      isShow: false,
      count: 0,
      dialogExportLoading: {
        open: false,
        text: ''
      },
      dialogConfirm: {
        open: false,
        text: '',
        textBtn: ''
      },
      objForExport: {},
      reportName: 'bot_qc',
      reportFileName: '',
      total: 0,
      checkpointValue: '1',
      channelTypeList: [
        { label: '(All)', value: 'all' },
        { label: 'Voice', value: 'voice' },
        { label: 'Chat', value: 'chat' }
      ],
      channels: [{ value: 'all', label: '(All)' }],
      channelSelected: '(All)'
    }
  },
  watch: {
    'search.channelType': {
      handler() {
        this.getChannel()
      }
    }
  },
  created() {
    document.title = this.$t('page-title.insight', {
      productName: this.$options.filters.getVariable('product_name')
    })

    this.search.from = Moment()
      .startOf('day')
      .format(this.format)
    this.search.to = Moment()
      .startOf('day')
      .add(1, 'days')
      .format(this.format)

    this.initial()
  },
  computed: {
    dateFrom() {
      return this.$options.filters.convertDatetimePicker(this.search.from)
    },
    dateTo() {
      return this.$options.filters.convertDatetimePicker(this.search.to)
    }
  },
  methods: {
    async initial() {
      await this.getListInsight()
      await this.getChannel()
    },
    async getListInsight() {
      try {
        const response = await apiInsight.getListInsight()
        const { data } = response

        this.insights = data

        if (this.insights.length > 0) {
          const find = _.find(this.insights, { value: 'checkpoint' })
          if (find) this.search.name = find.value
          else this.search.name = this.insights[0].value
        }
      } catch (error) {}
    },
    async getChannel() {
      try {
        const getChannel = await apiReport.getListChannel(
          this.search.channelType
        )
        const { data } = getChannel

        this.channels = [{ value: 'all', label: '(All)' }]

        for (const obj of data) {
          const list = {}

          list.value = obj._id
          list.label = obj.channel
          list.img = obj.img

          if (obj.platform === 'facebook') list.img = Facebook
          if (obj.platform === 'line') list.img = Line
          if (obj.platform === 'phone') {
            list.icon = 'mdi-phone-incoming'
            list.class = 'icon-voice-inbound'
          }

          this.channels.push(list)
        }
      } catch (error) {}
    },
    async getInsight() {
      try {
        setTimeout(() => {
          if (this.channelSelected) {
            if (this.channelSelected === '(All)') this.search.channel = 'all'
            else if (typeof this.channelSelected === 'string')
              this.search.channel = this.channelSelected
            else {
              const obj = _.find(this.channels, {
                label: this.channelSelected.value
              })
              this.search.channel = obj ? obj.value : this.channelSelected.value
            }
          }

          this.dialogExportLoading = {
            open: true,
            text: 'Loading...'
          }

          this.isShow = true
          this.count++

          this.objForExport = {
            name: this.search.name,
            from: this.search.from,
            to: this.search.to
          }
        }, 100)
      } catch {}
    },
    setBorderStyle() {
      this.isCalendarShow = true
    },
    async genReport(format) {
      const limitDownload =
        parseInt(process.env.VUE_APP_LIMIT_DOWNLOAD) || 10000

      if (this.total > limitDownload) {
        this.dialogConfirm.open = true
        this.dialogConfirm.text = `Maximum of <b>${limitDownload.toLocaleString(
          'en-US'
        )}</b> records can be downloaded at a time.<br />Please reduce date rage of the report and try again.`
        this.dialogConfirm.textBtn = 'OK'
      } else {
        let titleLoading
        let reportFileName
        let fileType
        let ext
        if (format === 'excel') {
          reportFileName = 'Bot QC'
          titleLoading = 'Exporting excel...'
          fileType = 'application/vnd.ms-excel'
          ext = 'xlsx'
        } else if (format === 'pdf') {
          reportFileName = 'Bot QC'
          titleLoading = 'Exporting PDF...'
          fileType = 'application/pdf'
          ext = 'pdf'
        } else if (format === 'csv') {
          reportFileName = 'QC result'
          titleLoading = 'Exporting CSV...'
          fileType = 'data:text/csv;charset=utf-8'
          ext = 'csv'
        }

        this.dialogExportLoading = {
          open: true,
          text: `${titleLoading}<br /><b>Do not close this window</b>`
        }

        setTimeout(async () => {
          let data
          let query
          if (format === 'excel') {
            query = {
              ...this.objForExport,
              total: this.total,
              color: {
                primary: variables.primary,
                primary_soft: variables.primarySoft,
                text_color: variables.textColor
              }
            }
            data = await apiInsight.exportExcel(this.reportName, query)
          } else if (format === 'pdf') {
            const el = document.createElement('div')
            el.style = 'width: 1in;'
            document.body.appendChild(el)
            const dpi = el.offsetWidth
            document.body.removeChild(el)

            query = {
              ...this.objForExport,
              total: this.total,
              color: {
                primary: variables.primary,
                primary_soft: variables.primarySoft,
                text_color: variables.textColor
              },
              dpi: dpi
            }
            data = await apiInsight.exportPdf(this.reportName, query)
          } else if (format === 'csv') {
            data = await apiInsight.exportCsv(
              this.reportName,
              this.objForExport
            )
          }

          const blob = new Blob([data], { type: fileType })
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)

          link.target = '_blank'
          link.download = `${reportFileName} - ${Moment(
            this.search.from
          ).format('YYYY-MM-DD')} to ${Moment(this.search.to).format(
            'YYYY-MM-DD'
          )}.${ext}`
          link.click()
          URL.revokeObjectURL(link.href)

          this.dialogExportLoading = {
            open: false,
            text: ''
          }
        }, 700)
      }
    },

    dataChange() {
      this.isCalendarShow = false
      this.isShow = false
      this.count = 0
      this.total = 0
    },
    checkFilter(value) {
      const obj = _.find(this.insights, { value: this.search.name })
      if (!obj) return false

      return obj['filter'] ? obj['filter'][value] : false
    },
    reportChange(value) {
      this.dataChange()

      for (let i = 0; i < this.insights.length; i++) {
        if (this.insights[i].value === value) {
          this.reportName = this.insights[i].value
          this.reportFileName = this.insights[i].name
        }
      }
    },
    checkTotalQc(count) {
      this.total = count
    },
    closeDialogLoading() {
      setTimeout(() => {
        this.dialogExportLoading = {
          open: false,
          text: ''
        }
      }, 200)
    },
    keyCheckpointValue(event) {
      this.checkpointValue = this.checkpointValue
        .replace(/,/g, '')
        .replace(/[^0-9]/g, '')
    },
    blurCheckpointValue() {
      this.checkpointValue = this.checkpointValue.replace(/,/g, '')
      let val = parseInt(this.checkpointValue || -1)

      if (val < 0) {
        val = 1
      }

      this.checkpointValue = val.toLocaleString()
      this.search.checkpoint_value = val
    }
  }
}
</script>

<style lang="scss" scoped>
.container-page {
  height: 100%;
}

.border1 {
  position: relative;
  height: calc(100vh - 127px);
  overflow-y: auto;
  background-color: #ffffff;
  border: 1px solid #c1c3d0;
  border-radius: 4px;
  padding: 20px;

  &.hide-scroll-y {
    overflow-y: unset;
  }
}

.border2 {
  position: relative;
  height: calc(100vh - 127px);
  // background-color: #ffffff;
  // border: 1px solid #c1c3d0;
  // border-radius: 2px;
}

.expand-filter {
  padding-left: 12px;
  padding-right: 12px;
}
.icon-expand-filter {
  position: absolute;
  top: 10px;
  right: 10px;
}

.icon-excel {
  font-size: 25px;
}

::v-deep thead th {
  border: 1px solid #cdcfd4;
}

::v-deep tbody td {
  border: 1px solid #cdcfd4;
}

::v-deep .v-data-table__wrapper {
  height: calc(100vh - 130px);
}

::v-deep .session_detail_report .v-data-table__wrapper {
  height: calc(100vh - 170px);
}

::v-deep .container-report {
  background-color: white;
  height: calc(100vh - 130px);
}
</style>
